import { BookerStateContext } from 'client/widgets/runtime-cal-booking/hooks/useRuntimeCalBookingState';
import { DesignStyle } from 'client/widgets/runtime-cal-booking/types';
import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';

const BookingSelectedHostMetaSection = ({
    selectedHostId,
}: {
    selectedHostId: number;
}) => {
    const [bookingState] = useContext(BookerStateContext);
    const selectedHost = useMemo(
        () =>
            bookingState.calEventData?.subsetOfHosts?.find?.(
                (host) => host.user.id === selectedHostId
            ),
        [bookingState.calEventData?.subsetOfHosts, selectedHostId]
    );

    if (!selectedHost) {
        return null;
    }

    return (
        <Container className='cal-booking-selected-host-meta-section'>
            <p>{selectedHost.user.name}</p>
        </Container>
    );
};

export default BookingSelectedHostMetaSection;

const Container = styled.div`
    line-height: 1.25rem;
    font-weight: 700;
    font-size: 14px;
    letter-spacing: 0px;
    color: #6c727f;
    margin-bottom: 10px;

    .${DesignStyle.SITE_THEME} & {
        color: var(--color_1);
    }

    p {
        margin: 0 !important;
    }
`;
